import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Settings } from '@folio/stripes/smart-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GeneralSettings from './GeneralSettings/GeneralSettings';
import CubeConnectionManager from './GeneralSettings/CubeConnectionManager';
import GeneralConfigManager from './GeneralSettings/GeneralConfigManager';
import EmailTemplateManager from './GeneralSettings/EmailTemplateManager';
import CategoriesSettings from './categoriesSettings/CategoriesSettings';
import AvailableTables from './DataModels/AvailableTables';
import AvailableColumns from './DataModels/AvailableColumns';
import AvailableMeasures from './DataModels/AvailableMeasures';
import ReportTypesSettings from './reportTypesSettings/ReportTypesSettings';

const settingsQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function ReportsSettings(props) {
  const sections = [
    {
      label: (
        <FormattedMessage
          id="ui-reports.settings.sections.general.label"
          defaultMessage="General"
        />
      ),
      pages: [
        {
          route: 'general',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.general.pages.generalSettings.lable"
              defaultMessage="General Settings"
            />
          ),
          component: GeneralSettings,
          perm: 'ui-reports.configs.manage',
        },
        {
          route: 'cube-connection',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.general.pages.cubeConnection.label"
            />
          ),
          component: CubeConnectionManager,
          perm: 'ui-reports.configs.manage',
        },
        {
          route: 'general-config',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.general.pages.generalConfig.label"
            />
          ),
          component: GeneralConfigManager,
          perm: 'ui-reports.configs.manage',
        },
        {
          route: 'email-templates',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.general.pages.emailTemplates.label"
              defaultMessage="Email Templates"
            />
          ),
          component: EmailTemplateManager,
          perm: 'ui-reports.configs.manage',
        },
      ],
    },
    {
      label: (
        <FormattedMessage
          id="ui-reports.settings.sections.categoriesAndTypes.label"
          defaultMessage="Categories & Types"
        />
      ),
      pages: [
        {
          route: 'categories',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.categories.pages.categoriesList.lable"
              defaultMessage="Reports Categories"
            />
          ),
          component: CategoriesSettings,
          perm: 'ui-reports.categories.view',
        },
        {
          route: 'report-types',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.general.pages.reportTypes.label"
              defaultMessage="Report Types"
            />
          ),
          component: ReportTypesSettings,
          perm: 'ui-reports.report-types.view',
        },
      ],
    },
    {
      label: (
        <FormattedMessage
          id="ui-reports.settings.sections.dataModels.label"
          defaultMessage="Data models"
        />
      ),
      pages: [
        {
          route: 'available-tables',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.dataModels.pages.availableTables.lable"
              defaultMessage="Available tables"
            />
          ),
          component: AvailableTables,
          perm: 'ui-reports.field-labels.view',
        },
        {
          route: 'available-columns',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.dataModels.availableColumns.label"
              defaultMessage="Available columns"
            />
          ),
          component: AvailableColumns,
          perm: 'ui-reports.field-labels.view',
        },
        {
          route: 'available-measures',
          label: (
            <FormattedMessage
              id="ui-reports.settings.sections.dataModels.availableMeasures.label"
              defaultMessage="Available measures"
            />
          ),
          component: AvailableMeasures,
          perm: 'ui-reports.field-labels.view',
        },
      ],
    },
  ];

  return (
    <QueryClientProvider client={settingsQueryClient}>
      <Settings
        {...props}
        sections={sections}
        paneTitle={
          <FormattedMessage
            id="ui-reports.meta.title"
            defaultMessage="Reports"
          />
        }
        navPaneWidth="20%"
      />
    </QueryClientProvider>
  );
}

ReportsSettings.propTypes = {};

export default ReportsSettings;
